import { computed, Injectable, OnDestroy, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class MobileService implements OnDestroy {
  private threshold = 1024;
  private threshold600 = 600;
  private resizeHandler: () => void;

  windowWidth = signal(window.innerWidth);
  isOn = computed(() => this.windowWidth() < this.threshold);
  isOn600 = computed(() => this.windowWidth() < this.threshold600);
  didChangeLastEvent = signal(false);

  constructor() {
    this.resizeHandler = () => {
      const wasOn = this.isOn();
      const currentWidth = window.innerWidth;
      this.windowWidth.set(currentWidth);
      this.didChangeLastEvent.set(wasOn !== currentWidth < this.threshold);
    };
    window.addEventListener('resize', this.resizeHandler);
  }

  ngOnDestroy() {
    window.removeEventListener('resize', this.resizeHandler);
  }
}
